var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconTrash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Property 1=\xEC\x82\xAD\xEC\xA0\x9C, \xEC\x83\x81\xED\x83\x9C=Default"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M4 5.62622H17M8.0625 3H12.9375M13.3438 17.8819H7.65625C6.75879 17.8819 6.03125 17.098 6.03125 16.1311L5.66026 6.53806C5.64103 6.04072 6.01006 5.62622 6.47206 5.62622H14.5279C14.9899 5.62622 15.359 6.04072 15.3397 6.53806L14.9688 16.1311C14.9688 17.098 14.2412 17.8819 13.3438 17.8819Z",
    stroke: "#73757C",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTrash);
export default __webpack_public_path__ + "static/media/Icon_trash.621866533a1ed931cf56855071cdbfb2.svg";
export { ForwardRef as ReactComponent };